import React, { useContext } from "react";
import { FormContext, FormContextProvider } from "@stormwater-software/lib-form";
import FormModal from "../../Shared/form/modal/FormModal";
import { FormSchemaFields } from "@stormwater-software/lib-form";
import { UIControlType } from "@stormwater-software/lib-form-control-types";

const ArchiveProjectForm = props => {
  const getSchema = () => {
    return {
      notes: {
        label: "If you would like to record any project specific notes prior to archiving the project please enter them below",
        controlType: UIControlType.textarea,
        rows: 4,
        validation: {
          required: false,
        },
        placeholder: "Enter notes here...",
      },
    };
  };

  return (
    <FormSchemaFields
      schema={getSchema()}
      formData={props.value}
      onChange={props.onChange}
    />
  );
};

const ArchiveProjectModalUI = props => {
  const formContext = useContext(FormContext);
  const { notes } = formContext.value;

  const handleSubmit = () =>
    props
      .handleArchive(notes)
      .then(() => {
        props.handleClose();
      });

  return (
    <FormModal
      modalProps={{
        title: "Are you sure you want to archive this project?",
        submitBtnText: "Yes, I understand",
      }}
      onCancel={props.handleClose}
      onSubmit={handleSubmit}
      dismissOnEsc={false}
      submitText={"Yes, I understand"}

    >
      <ArchiveProjectForm
        {...props}
        onChange={formContext.set}
        value={formContext.value}
      />
      {props.errorMsg && (
        <div className="error-message" style={{ color: 'red', marginTop: '1rem' }}>
          {props.errorMsg}
        </div>
      )}
    </FormModal>
  );
};

const ArchiveProjectModal = props => {
  if (!props.show) {
    return null;
  }

  return (
    <FormContextProvider>
      <ArchiveProjectModalUI {...props} />
    </FormContextProvider>
  );
};

export default ArchiveProjectModal;
